import { getErlenmeyerHalfWidthAtY, getPhysicsMouthGateTopY } from "./geometry.js";

export function createFlaskWalls(Bodies, geometry, wallOptions) {
  var cx = geometry.cx;
  var bodyTop = geometry.bodyTop;
  var bodyBottom = geometry.bodyBottom;
  var neckLeft = geometry.neckLeft;
  var neckRight = geometry.neckRight;
  var floorLeft = geometry.floorLeft != null ? geometry.floorLeft : cx - geometry.floorHalfWidth;
  var floorRight = geometry.floorRight != null ? geometry.floorRight : cx + geometry.floorHalfWidth;
  var floorHalfWidth = geometry.floorHalfWidth;
  var W = geometry.W;

  var walls = [];

  // Floor
  walls.push(Bodies.rectangle(cx, bodyBottom + W / 2, floorHalfWidth * 2 + W * 2, W, wallOptions));

  // Angled body walls: left goes from (neckLeft, bodyTop) → (floorLeft, bodyBottom)
  //                    right goes from (neckRight, bodyTop) → (floorRight, bodyBottom)
  // Use horizontal rectangular segments positioned along the straight line.
  var bodySegments = 20;
  for (var i = 0; i < bodySegments; i++) {
    var t0 = i / bodySegments;
    var t1 = (i + 1) / bodySegments;
    var y0 = bodyTop + (bodyBottom - bodyTop) * t0;
    var y1 = bodyTop + (bodyBottom - bodyTop) * t1;
    var yMid = (y0 + y1) / 2;
    var dy = Math.abs(y1 - y0);
    var tMid = (yMid - bodyTop) / (bodyBottom - bodyTop);
    var xLeft = neckLeft + (floorLeft - neckLeft) * tMid;
    var xRight = neckRight + (floorRight - neckRight) * tMid;
    walls.push(Bodies.rectangle(xLeft - W / 2, yMid, W, dy + 2, wallOptions));
    walls.push(Bodies.rectangle(xRight + W / 2, yMid, W, dy + 2, wallOptions));
  }

  // Vertical neck walls (physics gate down to shoulder — matches raised mouth seal)
  var gateTopY = getPhysicsMouthGateTopY(geometry);
  var neckH = bodyTop - gateTopY;
  if (neckH > 1) {
    var neckMidY = gateTopY + neckH / 2;
    walls.push(Bodies.rectangle(neckLeft - W / 2, neckMidY, W, neckH + 2, wallOptions));
    walls.push(Bodies.rectangle(neckRight + W / 2, neckMidY, W, neckH + 2, wallOptions));
  }

  return walls;
}

/** Stacked solid slabs at the physics gate — blocks solver ejection through a thin lid. */
export function createMouthSealBodies(Bodies, geometry, wallOptions) {
  var neckLeft = geometry.neckLeft;
  var neckRight = geometry.neckRight;
  var W = geometry.W;
  var cx = (neckLeft + neckRight) / 2;
  var sealWidth = Math.max(12, (neckRight - neckLeft) + W * 2);
  var layerHeight = Math.max(8, Math.min(12, W * 0.45));
  var gateTopY = getPhysicsMouthGateTopY(geometry);
  var seals = [];
  var layers = 3;
  for (var i = 0; i < layers; i++) {
    var topY = gateTopY - i * (layerHeight - 3);
    var sealY = topY + layerHeight / 2;
    seals.push(Bodies.rectangle(cx, sealY, sealWidth, layerHeight, wallOptions));
  }
  return seals;
}

export function createMouthSealBody(Bodies, geometry, wallOptions) {
  var seals = createMouthSealBodies(Bodies, geometry, wallOptions);
  return seals.length ? seals[0] : null;
}